/**
 * If approvalOdds prop is false, minCreditScoreRange and maxCreditScoreRange must be supplied.
 * minCreditScoreRange and maxCreditScoreRange must be valid selections from ficoArray
 */
// eslint-disable-next-line consistent-return
export var validateRequiredProps = function validateRequiredProps(props, propName) {
  var approvalOdds = props.approvalOdds,
      minCreditScoreRange = props.minCreditScoreRange,
      maxCreditScoreRange = props.maxCreditScoreRange; // if approvalOdds prop is not present or malformed, ensure that minCreditScoreRange and
  // maxCreditScoreRange are present and well-formed

  if (!approvalOdds && (!minCreditScoreRange && !maxCreditScoreRange || minCreditScoreRange && !maxCreditScoreRange || maxCreditScoreRange && !minCreditScoreRange)) {
    if (typeof minCreditScoreRange === 'string' || maxCreditScoreRange === 'string') {
      return new Error("".concat(propName, " is required when approvalOdds is false. Please provide a valid prop."));
    }
  }
}; // eslint-disable-next-line consistent-return

export var validateApprovalOddsProp = function validateApprovalOddsProp(props, propName) {
  var approvalOdds = props.approvalOdds; // approvalOdds must be a number between 0 and 1

  var isApprovalOddsPropValid = approvalOdds && typeof approvalOdds === 'number' && (approvalOdds >= 0 || approvalOdds <= 1); // if approvalOdds prop is present but malformed

  if (approvalOdds && !isApprovalOddsPropValid) {
    return new Error("".concat(propName, " must be a number between 0 and 1. Please provide a valid prop."));
  }
};